<template>
  <div id="HomeView" class="view" :style="minHeight">
    <page-intro 
      :sub-title="gpsst.homeSubTitle" 
      :view="'home'"
      v-on:changeview="$emit('changeview',$event)"
    ></page-intro>
    <div v-if="homeChapo_g" class="editorial" v-html="homeChapo_g"></div>

    <div class="cards-container">
      <section-card
        SectionCardId="1"
        :active="true"
        src="icons/entreprise-black.png"
        @click.native="changeView()"
      ></section-card>

      <div class="separator" :class="{'active': compagnyCompleted}"></div>

      <section-card
        SectionCardId="2"
        :active="compagnyCompleted"
        src="icons/themes-black.png"
        @click.native="themeCard()"
      ></section-card>

      <div class="separator" :class="{'active': synthesisAccessible}"></div>

      <section-card
        SectionCardId="3"
        :active="synthesisAccessible"
        src="icons/synthese-black.png"
        @click.native="synthesisCard()"
      ></section-card>
    </div>

    <page-menu
      :view="'home'"
      v-on:changeview="$emit('changeview',$event)"
    ></page-menu>
  </div>
</template>

<script>
import PageIntro from "../components/PageIntro";
import PageMenu from "../components/PageMenu";
import SectionCard from "../components/home/SectionCard";

export default {
  name: "HomeView",
  components: {
    PageIntro,
    PageMenu,
    SectionCard
  },
  props: {
    reloadHome: Number,
    minHeight: String
  },
  computed: {
    gpsst: function() {
      return this.$store.state.gpsstModule.gpsst;
    },
    homeChapo_g: function() {
      return JsonDataModule.getValueWithGlossary(this.gpsst, 'homeChapo'); //eslint-disable-line no-undef
    },
    compagnyCompleted: function() {
      return this.$store.state.appState.compagnyCompleted;
    },
    // on regarde si l'accès à la synthèse est possible (= si au moins 1 thème n'est pas au status 'empty')
    synthesisAccessible: function() {
      var themes = this.$store.state.gpsstModule.gpsst.themes;
      if (this.compagnyCompleted) {
        for (let i = 0; i < themes.length; i++) {
          if (
            themes[i].status == "complete" ||
            themes[i].status == "incomplete"
          ) {
            return true;
          }
        }
        return false
      }
      return false
    }
  },
  mounted: function() {
    initTooltips("#HomeView"); //eslint-disable-line no-undef
  },
  updated: function() {
    initTooltips("#HomeView"); //eslint-disable-line no-undef
  },  
  methods: {
    themeCard: function() {
      if (this.compagnyCompleted) {
        this.$emit("changeview", { view: "themesList" });
      }
    },
    synthesisCard: function() {
      if (this.synthesisAccessible) {
        this.$emit("changeview", { view: "synthesis" });
      }
    },
    changeView: function() {
       dataLayer.push ({
          'event': 'etools.interaction',
          'etool_action': 'Commencer l\'évaluation',
          'etool_name': 'Outil GPSST',
          'etool_step': 'Début'
      });
      this.$emit("changeview", { view: "compagny" });
    }
  }
};
</script>

<style lang="sass" scoped>
.cards-container
  display: flex
  flex-direction: column
  margin: 2.35rem 0
  width: fit-content

.separator
  width: 3px
  background-color: #B5B5B5
  margin-top: 10px
  margin-bottom: 15px
  margin-left: 13px // centers under the 30px circle (30/2 - 3/2)
  height: 2rem

  &.active
    background-color: #E85D2B

</style>
